module.exports = __webpack_public_path__ + "../../static/vue/img/seeded.eabe4f0f.png";